import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IReportFilter } from '../../../utils/interfaces/report-filter';

@Component({
  selector: 'app-print-filter-data',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './print-filter-data.component.html',
  styleUrl: './print-filter-data.component.scss',
})
export class PrintFilterDataComponent {
  filter = input.required<IReportFilter>();
}
